module.exports = __webpack_public_path__ + "static/media/Werner Ave Daly City, CA (3 Houses)3.cdac52b8.jpg";